import { Link } from "react-router-dom";
import logo from "../assets/images/visaro-logo.svg";
import { useAuth } from "../context/AuthContext";
import { Spinner } from "@phosphor-icons/react";

const SignUpNavbar = () => {
  const { user, isFetchingUser, logout } = useAuth();
  return (
    <nav className="p-4 md:px-10 flex items-center justify-center border border-gray-100 sticky top-0">
      <div className="max-w-3xl w-full flex items-center justify-between">
        <Link to="/">
          <img src={logo} alt="Visaro's Logo" />
        </Link>
        <div></div>
        <div className="flex items-center gap-4">
          {!isFetchingUser ? (
            user ? (
              <>
                <button
                  onClick={logout}
                  className="p-3 px-5 border-deepBlue border rounded-lg font-bold text-sm text-deepBlue"
                >
                  Log Out
                </button>
              </>
            ) : (
              <Link
                to="/login"
                className="p-3 px-5 border-deepBlue border rounded-lg font-bold text-sm text-deepBlue"
              >
                Log in
              </Link>
            )
          ) : (
            <div>
              <Spinner className="animate-spin size-6" />
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default SignUpNavbar;
